import { render, staticRenderFns } from "./OpeningHours.vue?vue&type=template&id=87fe80f6&scoped=true"
import script from "./OpeningHours.vue?vue&type=script&lang=js"
export * from "./OpeningHours.vue?vue&type=script&lang=js"
import style0 from "./OpeningHours.vue?vue&type=style&index=0&id=87fe80f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe80f6",
  null
  
)

export default component.exports